import React from "react";
import jwt_decode from "jwt-decode";
import {geDataFormat, logOut} from "../../common/utils";

export default class Menucustom extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showDashboard: false,
      showSegnalazioni: true,
      showDashboardMappatura: false,
      nome: "",
      cognome: "",
      numeroMatricola: "",
      ruolo: "",
    };
  }

  componentDidMount() {
    var objUser = JSON.parse(sessionStorage.getItem("user"));
    var objSegnalazioni = JSON.parse(sessionStorage.getItem("Imp_help_desk"));
    var objMappatura = JSON.parse(sessionStorage.getItem("Imp_mappatura"));

    if (objSegnalazioni === "1") {
      this.state.showSegnalazioni = true;
    } else {
      this.state.showSegnalazioni = false;
    }

    if (objMappatura === "1") {
      this.state.showDashboardMappatura = true;
    } else {
      this.state.showDashboardMappatura = false;
    }

    var decoded = jwt_decode(objUser.token);
    this.setState({
      nome: decoded.NOME,
      cognome: decoded.COGNOME,
      numeroMatricola: decoded.sub,
      ruolo: decoded.RUOLO,
    });
    //  this.state.nome = decoded.NOME;
    //  this.state.cognome = decoded.COGNOME;
    //  this.state.numeroMatricola = decoded.sub;

    var bool = parseInt(decoded.RUOLO) >= 2 ? false : true;
    this.setState({ showDashboard: bool });
  }

  render() {
    let content = this.state.showDashboard ? (
      <ul
        className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
        id="accordionSidebar"
      >
        <a
          className="sidebar-brand d-flex align-items-center justify-content-center"
          href="#/profile"
          onClick={() => {
            sessionStorage.removeItem("numeroControllorePayroll");
            sessionStorage.removeItem("dataInizioPayroll");
            sessionStorage.removeItem("dataFinePayroll");
          }}
        >
          <div className="sidebar-brand-icon rotate-n-15">
            <i className="fas fa-laugh-wink"></i>
          </div>
          <div className="sidebar-brand-text mx-3">
            {this.state.numeroMatricola}
          </div>
        </a>
        <hr className="sidebar-divider my-0"></hr>
        <li className="nav-item ">
          <a className="nav-link" href="#">
            <i className="fas fa-solid fa-clipboard"></i>
            <span>Sanzioni</span>
          </a>
        </li>
        <hr className="sidebar-divider my-0"></hr>
        <li className="nav-item">
          <a className="nav-link" onClick={logOut}>
            <i className="fas fa-fw fa-arrow-alt-circle-left"></i>
            <span>Logout</span>
          </a>
        </li>
        <hr className="sidebar-divider my-0"></hr>
      </ul>
    ) : (
      <ul
        className="navbar-nav bg-gradient-primary sidebar sidebar-dark accordion"
        id="accordionSidebar"
      >
        <a
          className="sidebar-brand d-flex align-items-center justify-content-center"
          href="#/profile"
        >
          <div className="sidebar-brand-icon rotate-n-15">
            <i className="fas fa-laugh-wink"></i>
          </div>
          <div className="sidebar-brand-text mx-3">
            {this.state.numeroMatricola}
          </div>
        </a>
        <hr className="sidebar-divider my-0"/>
        <li className="nav-item">
          <a
            className="nav-link"
            href="#/RicercaRapida"
            onClick={() => {
              sessionStorage.removeItem("numeroControllorePayroll");
              sessionStorage.removeItem("dataInizioPayroll");
              sessionStorage.removeItem("dataFinePayroll");
            }}
          >
            &nbsp; <i className="fas fa-fw fa-money-check-alt"></i>
            Ricerca Rapida
          </a>
        </li>
        <hr className="sidebar-divider my-0"/>
        <li class="nav-item dropdown">
          <a
            class="nav-link dropdown-toggle"
            href="#"
            id="navbarDropdown"
            role="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            &nbsp; <i className="fas fa-fw fa-newspaper"></i> Sanzioni
          </a>
          <ul
            className="dropdown-menu"
            aria-labelledby="navbarDropdown"
            style={{ backgroundColor: "#4e73df", width: "100%" }}
          >
            <li>
              <a
                className="dropdown-item"
                id="searchDaLavorare"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?daLav";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp;&nbsp;
                <span>Da lavorare</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            <li>
              <a
                className="dropdown-item"
                id="searchInLavorazione"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?inLav";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>In lavorazione</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            <li>
              {/* <a
                className="dropdown-item"
                id="searchPostalizzate"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?postalizzate";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Postalizzate</span>
              </a> */}
            </li>
            {/* <hr className="sidebar-divider"></hr> */}
            <li>
              <a
                className="dropdown-item"
                id="searchPagate"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?pagate";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Pagate</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            {/* <li>
              <a
                className="dropdown-item"
                id="searchPagate"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?rateizzati";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Rateizzata</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr> */}
            <li>
              <a
                className="dropdown-item"
                id="searchRavvedimentoOperoso"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?ravvedimentoOperoso";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Ravvedimento operoso</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            <li>
              <a
                className="dropdown-item"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?agliAtti";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Agli atti</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            <li>
              <a
                className="dropdown-item"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?annullate";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Annullate</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            <li>
              <a
                className="dropdown-item"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                  window.location.href = "#/home?altri";
                  window.location.reload();
                }}
              >
                <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Altri</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            <li>
              <a class="dropdown-item" onClick={()=>{
                window.location.href = "#/esportaSpacchettatoSanzioni"
              }}>
              <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Esporta Spacchettato</span>
              </a>
            </li>
            <hr className="sidebar-divider"></hr>
            <li>
              <a class="dropdown-item" onClick={()=>{
                window.location.href = "#/importaSanzioni"
              }}>
              <i className="fas fa-fw fa-newspaper"></i> &nbsp; &nbsp;
                <span>Importa Sanzioni</span>
              </a>
            </li>
          </ul>
        </li>
        
        <hr className="sidebar-divider"></hr>

            <li class="nav-item dropdown">
              <a
                class="nav-link dropdown-toggle"
                href="#"
                id="navbarDropdown"
                role="button"
                data-bs-toggle="dropdown"
                aria-expanded="false"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                }}
              >
                &nbsp; <i className="fas fa-fw fa-tachometer-alt"></i> Dashboard
              </a>
              <ul
                className="dropdown-menu"
                aria-labelledby="navbarDropdown"
                style={{ backgroundColor: "#4e73df", width: "100%" }}
              >
                <li>
                  <a
                    className="dropdown-item"
                    onClick={() => {
                      sessionStorage.removeItem("numeroControllorePayroll");
                      sessionStorage.removeItem("dataInizioPayroll");
                      sessionStorage.removeItem("dataFinePayroll");
                    }}
                    href="#/dashboardSanzioni"
                  >
                    <i className="fas fa-fw fa-tachometer-alt"></i> &nbsp;&nbsp;
                    <span>Sanzioni</span>
                  </a>
                </li>

                {this.state.showDashboardMappatura ? (
                  <>
                    <hr className="sidebar-divider"></hr>
                    <li>
                      <a
                        className="dropdown-item"
                        onClick={() => {
                          sessionStorage.removeItem("numeroControllorePayroll");
                          sessionStorage.removeItem("dataInizioPayroll");
                          sessionStorage.removeItem("dataFinePayroll");
                        }}
                        href="#/dashboardMappature"
                      >
                        <i className="fas fa-fw fa-map"></i> &nbsp; &nbsp;
                        <span>Mappature</span>
                      </a>
                    </li>
                  </>
                ) : (
                  ""
                )}
              </ul>
            </li>
            <hr className="sidebar-divider"></hr>

        {/* <li className="nav-item">
           <a className="nav-link"  href="#/dashboard">
           &nbsp;<i className=""></i>
           <span>Dashboard</span></a>
        </li> */}

        <li className="nav-item">
          <a
            className="nav-link"
            href="#/recidivi"
            onClick={() => {
              sessionStorage.removeItem("numeroControllorePayroll");
              sessionStorage.removeItem("dataInizioPayroll");
              sessionStorage.removeItem("dataFinePayroll");
            }}
          >
            &nbsp;&nbsp;<i className="fas fa-fw fa-angry"></i>
            <span>Recidivi</span>
          </a>
        </li>
        {/* {this.state.ruolo == 4 ? (
          <>
            <hr className="sidebar-divider"></hr>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#/Payroll"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                }}
              >
                &nbsp;&nbsp;<i className="fas fa-file-invoice-dollar"></i>
                <span> Payroll</span>
              </a>
            </li>{" "}
          </>
        ) : (
          ""
        )} */}
        {parseInt(this.state.ruolo) == 4 ? (
          <li class="nav-item dropdown">
            <hr className="sidebar-divider"></hr>
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="navbarDropdown"
              role="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
              onClick={() => {
                sessionStorage.removeItem("numeroControllorePayroll");
                sessionStorage.removeItem("dataInizioPayroll");
                sessionStorage.removeItem("dataFinePayroll");
              }}
            >
              &nbsp; <i className="fas fa-fw fa-edit"></i> Impostazioni
            </a>
            <ul
              className="dropdown-menu"
              aria-labelledby="navbarDropdown"
              style={{ backgroundColor: "#4e73df", width: "100%" }}
            >
              <li>
                <a
                  className="dropdown-item"
                  href="#/impostazioneSanzione"
                  onClick={() => {
                    sessionStorage.removeItem("numeroControllorePayroll");
                    sessionStorage.removeItem("dataInizioPayroll");
                    sessionStorage.removeItem("dataFinePayroll");
                  }}
                >
                  <i className="fas fa-fw fa-cogs"></i> &nbsp;&nbsp;
                  <span>Configurazioni</span>
                </a>
              </li>
              <hr className="sidebar-divider"></hr>
              <li>
                <a
                  className="dropdown-item"
                  href="#/manageProfile"
                  onClick={() => {
                    sessionStorage.removeItem("numeroControllorePayroll");
                    sessionStorage.removeItem("dataInizioPayroll");
                    sessionStorage.removeItem("dataFinePayroll");
                  }}
                >
                  <i className="fas fa-fw fa-user"></i> &nbsp;&nbsp;
                  <span>Utenti</span>
                </a>
              </li>
              <hr className="sidebar-divider"></hr>
              <li>
                <a
                  className="dropdown-item"
                  href="#/TipologiaSanzione"
                  onClick={() => {
                    sessionStorage.removeItem("numeroControllorePayroll");
                    sessionStorage.removeItem("dataInizioPayroll");
                    sessionStorage.removeItem("dataFinePayroll");
                  }}
                >
                  <i className="fas fa-fw fa-list-ul"></i> &nbsp;&nbsp;
                  <span>Tipologia Sanzioni</span>
                </a>
              </li>
              <hr className="sidebar-divider"></hr>
              <li>
                <a
                  className="dropdown-item"
                  href="#/tipoDocumento"
                  onClick={() => {
                    sessionStorage.removeItem("numeroControllorePayroll");
                    sessionStorage.removeItem("dataInizioPayroll");
                    sessionStorage.removeItem("dataFinePayroll");
                  }}
                >
                  <i class="fas fa-solid fa-id-card"></i> &nbsp;&nbsp;
                  <span>Tipo Documento</span>
                </a>
              </li>
              <hr className="sidebar-divider"></hr>
              <li>
                <a
                  className="dropdown-item"
                  href="#/lineaMezzo"
                  onClick={() => {
                    sessionStorage.removeItem("numeroControllorePayroll");
                    sessionStorage.removeItem("dataInizioPayroll");
                    sessionStorage.removeItem("dataFinePayroll");
                  }}
                >
                  <i class="fas fa-solid fa-id-card"></i> &nbsp;&nbsp;
                  <span>Linea Mezzo</span>
                </a>
              </li>
            </ul>
          </li>
        ) : (
          ""
        )}

        {this.state.showSegnalazioni ? (
          <>
            <hr className="sidebar-divider"></hr>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#/tickets"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                }}
              >
                &nbsp; <i className="fas fa-fw fa-hands-helping"></i>
                <span>Segnalazioni</span>
              </a>
            </li>
          </>
        ) : (
          ""
        )}

        {/* {parseInt(this.state.ruolo) === 4 ? (
          ""
        ) : (
          <>
            <hr className="sidebar-divider"></hr>
            <li className="nav-item">
              <a
                className="nav-link"
                href="#/profile"
                onClick={() => {
                  sessionStorage.removeItem("numeroControllorePayroll");
                  sessionStorage.removeItem("dataInizioPayroll");
                  sessionStorage.removeItem("dataFinePayroll");
                }}
              >
                &nbsp; <i className="fas fa-fw fa-solid fa-user"></i>
                <span>Profile</span>
              </a>
            </li>
          </>
        )} */}

        <hr className="sidebar-divider"></hr>
        <li className="nav-item">
          <a className="nav-link" onClick={logOut}>
            &nbsp; <i className="fas fa-fw fa-arrow-alt-circle-left"></i>
            <span>Logout</span>
          </a>
        </li>
        <hr className="sidebar-divider"></hr>
      </ul>
    );
    return <React.Fragment>{content}</React.Fragment>;
  }
}
